import React, { useLayoutEffect, useState, useEffect } from "react";

// Animations
import { TypeAnimation } from "react-type-animation";
import { Fade } from "react-reveal";

// Custom Components
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

// Custom Styles
import "./HomeStyles.css";

export default function Home() {
    // States
    const [aboutIsHovered, setAboutIsHovered] = useState(false);
    const [portfolioIsHovered, setPortfolioIsHovered] = useState(false);


    // Size Handling for Type Animation Re-renders
    React.useEffect(() => {
        document.title = "Homepage | Stone Culver";
    })

    const [width, setWidth] = useState(window.innerWidth);

    // add this useEffect hook
    useEffect(() => {
        function handleResize() {
            setWidth(window.innerWidth);
        }

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Renders

    const renderLogoImage = () => {
        if (width > 1100) {
            return (
                <>
                    <img className='logo-image'
                        src="/images/logo3.png"
                    />
                </>
            )
        }
    }

    const renderHomepageButtons = () => {
        if (width > 900) {
            return (
                <>
                    <div className="home-page-buttons-item home-page-button-container">
                        <Fade delay={150}>
                            <form action='/about'>
                                <button action='submit'>
                                    <img src={aboutIsHovered ? '/images/aboutme-selected.png' : '/images/aboutme-button.png'}
                                        className={'home-page-button-image'}
                                        onMouseEnter={() => setAboutIsHovered(true)}
                                        onMouseLeave={() => setAboutIsHovered(false)}
                                    />
                                </button>
                            </form>
                        </Fade>
                    </div>
                    <div className="home-page-buttons-item home-page-button-container">
                        <Fade delay={300}>
                            <form action='/projects'>
                                <button action='submit'>
                                    <img
                                        className={'home-page-button-image'}
                                        src={portfolioIsHovered ? '/images/portfolio-selected.png' : '/images/portfolio-button.png'}
                                        onMouseEnter={() => setPortfolioIsHovered(true)}
                                        onMouseLeave={() => setPortfolioIsHovered(false)}
                                    />
                                </button>
                            </form>
                        </Fade>
                    </div>
                </>
            )
        } else {
            return (
                <>
                    <div className="home-page-mobile-buttons-container">
                        <div className="home-page-buttons-item home-page-button-container">
                            <Fade delay={150}>
                                <form action='/about'>
                                    <button action='submit'>
                                        <img src={aboutIsHovered ? '/images/aboutme-selected.png' : '/images/aboutme-button.png'}
                                            className={'home-page-button-image'}
                                            onMouseEnter={() => setAboutIsHovered(true)}
                                            onMouseLeave={() => setAboutIsHovered(false)}
                                        />
                                    </button>
                                </form>
                            </Fade>
                        </div>
                        <div className="home-page-buttons-item home-page-button-container">
                            <Fade delay={300}>
                                <form action='/projects'>
                                    <button action='submit'>
                                        <img
                                            className={'home-page-button-image'}
                                            src={portfolioIsHovered ? '/images/portfolio-selected.png' : '/images/portfolio-button.png'}
                                            onMouseEnter={() => setPortfolioIsHovered(true)}
                                            onMouseLeave={() => setPortfolioIsHovered(false)}
                                        />
                                    </button>
                                </form>
                            </Fade>
                        </div>
                    </div>

                </>
            )
        }
    }

    // Prevents elements which depend on width attribute from loading incorrectly

    if (width === 0) {
        return <></>
    }

    return (
        <>
            <div className="home">
                    <Navbar />

                {/* <div className='logo-container'>
                    <Fade>
                        <img className='website-logo' src='/images/logo.png'/>
                    </Fade>
                </div> */}
                <div className='home-header-container'>
                    <div className="home-header">
                        <div className="home-header-text container-shadow">
                            <TypeAnimation
                                sequence={[
                                    '', 300, 'Stone Culver', 1500
                                ]}
                                speed={30}
                                cursor={false}
                                style={{
                                    fontFamily: 'Daydream',
                                    fontWeight: '800',
                                    color: "#fff",
                                }}
                                className={'homepage-type-text-header'}
                            />

                            <TypeAnimation
                                sequence={[
                                    '',
                                    1500, 'Freelancer',
                                    1000, 'Web Developer',
                                    1000, 'Software Engineer',
                                ]}
                                style={{
                                    fontFamily: 'Daydream',
                                    fontWeight: '800',
                                    color: "#123458",
                                }}
                                className={'homepage-type-text-subheader'}
                            />
                            <Fade delay={300}>
                                <p>I'm a fullstack developer living in Estonia with experience working for businesses in Finland and America. </p>
                                <p>Thanks for stopping by!</p>
                            </Fade>
                        </div>

                        {renderLogoImage()}
                    </div>
                </div>

                <div className="home-page-buttons">
                    <div className="home-page-buttons-item welcome-gif-container">
                        <img className='welcome-gif'
                            src="/images/welcome.gif"
                        />
                    </div>
                    {renderHomepageButtons()}
                </div>

                <Footer width={width} />
            </div>


        </>
    )
}